module.exports = __webpack_public_path__ + "static/media/KDriver_OnItsWay.9e7e226d.gif";